import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'; 

// --- Import all Components ---
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import SubNav from './components/SubNav/SubNav';
import IntegratedCoverage from './components/IntegratedCoverage/IntegratedCoverage';
import Commodities from './components/Commodities/Commodities';
import ProvenanceAdvantage from './components/ProvenanceAdvantage/ProvenanceAdvantage';
import SpeakToExpert from './components/SpeakToExpert/SpeakToExpert';
import Newsletter from './components/Newsletter/Newsletter';
import Footer from './components/Footer/Footer';

import CareersModal from './components/CareersModal/CareersModal';
import MarketHighlights from './components/MarketHighlights/MarketHighlights';

// --- Home Page Component ---
// This contains the logic specific to the main landing page
const Home = () => {
  // State for Modals
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isCareersOpen, setIsCareersOpen] = useState(false);

  return (
    <>
      {/* Navbar with triggers for Modals */}
      <Navbar 
        onOpenForm={() => setIsFormOpen(true)} 
        onOpenCareers={() => setIsCareersOpen(true)} 
      />
      
      {/* Main Page Sections */}
      <Hero />
      <SubNav />
      <IntegratedCoverage />
      <Commodities />
      <ProvenanceAdvantage />
      
      {/* 1. Inline "Speak to Expert" Section (Visible on page) */}
      <SpeakToExpert isModal={false} />
      
      {/* 2. Modal "Speak to Expert" (Popup - Hidden by default) */}
      {isFormOpen && (
        <SpeakToExpert 
          isModal={true} 
          onClose={() => setIsFormOpen(false)} 
        />
      )}

      {/* 3. Modal "Careers" (Popup - Hidden by default) */}
      {isCareersOpen && (
        <CareersModal 
          onClose={() => setIsCareersOpen(false)} 
        />
      )}
      
      <Newsletter />
      <Footer />
      
    </>
  );
};

// --- Main App Component ---
// This handles the Routing (Navigation between pages)
function App() {
  
  // Optional: Check if Backend is alive when App starts
  useEffect(() => {
    fetch('http://127.0.0.1:5000/api/status')
      .then(res => res.json())
      .then(data => console.log("Backend Status:", data))
      .catch(err => console.log("Backend not running yet"));
  }, []);

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Route for the Main Homepage */}
          <Route path="/" element={<Home />} />
          
          {/* Route for the Market Highlights Page */}
          <Route path="/market-highlights" element={<MarketHighlights />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;